import React, { useState } from "react";
import Pagination from "react-bootstrap-4-pagination";

const PaginationComponent = () => {
  const [currentPage, setCurrentPage] = useState(1);
  return (
    <div className="container">
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          flexFlow: "row wrap",
          textAlign: "center",
          marginTop: 5,
        }}
      >
        <Pagination
          circle
          threeDots
          prevNext={true}
          totalPages={20}
          currentPage={currentPage}
          showMax={5}
          activeBgColor="#3f51b5"
          activeBorderColor="#ffff"
          bgColor="#b8b8b8"
          borderColor="#fffff"
          disabledBgColor="#ffffff"
          disabledBorderColor="#000"
          color="#ffffff"
          onClick={(id) => setCurrentPage(id)}
        />
      </div>
    </div>
  );
};

export default PaginationComponent;
